import React from 'react';
import Seo from '../components/Seo';
import ContentPostList from '../components/content/ContentPostList';
import { newsService } from '../api';
import './InfoPages.css';

const NewsPage = () => (
    <div className="info-page">
        <Seo title="Новости сайта" description="Новости и обновления Dealzy." />
        <h1 className="info-page__title">Новости сайта</h1>
        <ContentPostList service={newsService} basePath="/news" />
    </div>
);

export default NewsPage;
